import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useCallback, useRef } from 'react';
import { DynamicForm } from 'src/components/Forms';
import {
  ProjectStages,
  SubmitProposalLostPayload,
  useProjectStages,
  useSubmitProposalLost,
} from 'src/graphql';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { ProposalLostFormValues, useProposalLostForm } from './use-proposal-lost-form';

export const ProposalLostModal = () => {
  const { closeModal } = useModalMethods(Modals.ProposalLost);
  const { isOpened, modalProps } = useModalState(Modals.ProposalLost);

  const submitButtonRef = useRef<HTMLButtonElement | null>(null);
  const triggerSubmit = useCallback(() => {
    submitButtonRef?.current?.click();
  }, []);

  const { proposalLostFormFields } = useProposalLostForm();
  const { submitProposalLost } = useSubmitProposalLost();
  const { projectStages } = useProjectStages({
    filters: [
      {
        attribute: 'projectStageId',
        operator: '=',
        value: ProjectStages.ProposalLost.toString(),
      },
    ],
    limit: 1,
  });

  const onSubmit = useCallback(
    async (data: ProposalLostFormValues) => {
      const project = modalProps?.project;
      const address = modalProps?.address;

      if ((!project?.id && !project?.projectId) || (!address?.id && !address?.addressId)) {
        return;
      }

      const payload: SubmitProposalLostPayload = {
        projectId: project.projectId || project.id,
        addressId: address.addressId || address.id,
        partnerId: address.partnerId,
        projectLostReasonId: data.projectLostReason.id,
        lostReasonNotes: data.lostReasonNotes,
      };

      closeModal();
      await submitProposalLost(
        payload,
        {
          ...project,
          projectStage: projectStages?.[0],
        },
        address,
      );
    },
    [closeModal, modalProps?.address, modalProps?.project, projectStages, submitProposalLost],
  );

  return (
    <Dialog open={isOpened} onClose={closeModal} fullWidth>
      <DialogTitle>
        <Typography>Proposal Lost</Typography>
      </DialogTitle>
      <DialogContent>
        <DynamicForm
          style={{ gap: '1rem' }}
          fields={proposalLostFormFields}
          onSubmit={onSubmit}
        >
          <Button
            type="submit"
            ref={submitButtonRef}
            sx={{
              display: 'none',
            }}
          >
            Save
          </Button>
        </DynamicForm>
        <DialogActions>
          <Button onClick={triggerSubmit}>Submit</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
